import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useTranslateOptionLabel } from 'src/hooks/useTranslateOptionLabel';
import type { Option } from 'src/types';
import { useTaskTablesContext } from '../../context';
import { TimeFrame } from '../../types';

const options = Object.values(TimeFrame).map((item) => ({
  label: item,
  value: item,
}));

export const TimeFrameFilter: FC = () => {
  const [t] = useTranslation(['backend', 'common', 'serviceDashboard']);
  const formatOptionLabel = useTranslateOptionLabel(t, 'serviceDashboard');
  const filters = useTaskTablesContext('filters$');
  const { updateFilter } = useTaskTablesContext();

  const handleChange = useCallbackRef((option: Option<TimeFrame> | null) => {
    updateFilter('timeFrame', option);
  });

  return (
    <Filter<TimeFrame>
      label={t('common:TIME_FRAME')}
      options={options}
      selected={filters.timeFrame}
      onChange={handleChange}
      formatOptionLabel={formatOptionLabel}
      isClearable
      dataTestId='time-frame-filter'
    />
  );
};
